
import {
  getCategoryMenu,
} from '@/api/contact/category'

export async function getCategoryMenuAction ({ commit }, payload) {
  try {
    const { data } = await getCategoryMenu(payload);
    commit('setTravelAuth', { data });
    return data;
  } catch (e) {
    console.log(e)
  }
}

export default {
  getCategoryMenuAction,
}
